<template>
  <div class="app-container">
    <div class="filter-container">
      <el-date-picker
        class="filter-item"
        v-model="dateArr"
        type="datetimerange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd HH:mm:ss"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>

      <el-input
        v-model="listQuery.nickname"
        placeholder="请输入昵称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.title"
        placeholder="请输入标题"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.comment_content"
        placeholder="请输入评论内容"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="原帖标题" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.post.title }}
        </template>
      </el-table-column>
      <el-table-column label="评论人ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="评论人头像" min-width="110" align="center">
        <template slot-scope="scope">
          <el-image
            style="height: 60px"
            :preview-src-list="[scope.row.user.avatar]"
            :src="scope.row.user.avatar"
            class="banner-image"
            lazy
          />
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.user.nickname }} </template>
      </el-table-column>
      <el-table-column label="评论内容" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.content }} </template>
      </el-table-column>
      <el-table-column label="点赞人数" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.like_num }} </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on == 1" type="success">正常</el-tag>
          <el-tag v-else type="danger">已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="发布时间" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.created_at }} </template>
      </el-table-column>

      <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleDetail(scope.row)"
            >查看详情</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id, '删除')"
            >删除</el-button
          >
          <el-button
            style="margin-top: 10px"
            v-if="scope.row.is_on == 1"
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '冻结')"
            >冻结</el-button
          >
          <el-button
            style="margin-top: 10px"
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '解冻')"
            >解冻</el-button
          >
          <!-- <el-button
            style="margin-top: 10px"
            size="mini"
            type="warning"
            @click="handleTips(scope.row)"
            >提醒修改</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      dateArr: null,
      listQuery: {
        page: 1,
        limit: 10,
        start_at: "",
        end_at: "",
        nickname: "",
        title: "",
        comment_content: "",
      },
      dialogFormVisible: false,
      form: {
        user_id: "",
        forum_post_message_id: "", //评论id
        content: "", //提醒内容
      },
      rules: {
        name: [
          { required: true, message: "院系不能为空", trigger: "change" },
        ],
      },
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/post/commentList",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    getDetail(id) {
      request({
        url: "/api/backend/post/commentDetail",
        method: "get",
        params: { id },
      }).then((response) => {});
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
      };
    },
    handleDetail(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
      this.getDetail(row.id);
    },
    handleTips(row) {
      console.log(row);
      this.$prompt('请输入提现的内容', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          request({
              url: "/api/backend/post/commentRemindStore",
              method: "post",
              params: {
                user_id:row.user_id,
                forum_post_message_id:row.id,
                content:value,
              },
          }).then((response) => {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getList();
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });

    },
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该院系, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/post/commentUpDown",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    handleDelete(val, text) {
      this.$confirm("此操作将" + text + "该条评论, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/post/commentDel",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
